import { render } from "./Click610ShortIcon.vue?vue&type=template&id=41f4c670"
import script from "./Click610ShortIcon.vue?vue&type=script&lang=js"
export * from "./Click610ShortIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__